import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { CommonModule } from '@angular/common';
import {
  EvChargingInvoiceResponse,
  ParkingUserVehicleDto,
} from '../../../../../core/models/ev.model';
import { PaymentTopupParkingPayload, PaymentTopupPenaltyPayload } from '../../../../../core/models/payment.model';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiHandlerService } from '../../../../../tools/services/api/handler-api/apiHandler.service';
import { FormsModule } from '@angular/forms';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { CookieService } from 'ngx-cookie-service';
import { CityParkingAccountTopUp } from '../../../../../core/models/topUpAccount.model';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { ApiParkingService } from '../../../../../core/services/api/Parking/api-parking';
import { ApiPaymentService } from '../../../../../core/services/api/Payment/api-payment';
import { ApiEvChargerService } from '../../../../../core/services/api/Ev-chager/api-Ev-Carger';

@Component({
  selector: 'app-ev-charger-invoice',
  imports: [CommonModule, FormsModule, PssLoadingComponent],
  templateUrl: './ev-charger-invoice.component.html',
  styleUrl: './ev-charger-invoice.component.css',
})
export class EvChargerInvoiceComponent {
  currentLang: 'TH' | 'EN' = 'TH';
  /* -- User --*/
  uid: string = '';
  token: string = '';

  /* -- Invoice --*/
  invoiceList: EvChargingInvoiceResponse[] = [
    // {
    //   id: 1,
    //   name: 'ทดสอบ',
    //   feeName: 'ทดสอบค่าธรรมเนียม',
    //   siteId: 1,
    //   siteName: 'Paragon',
    //   siteEv: 'A3',
    //   fee: 100,
    //   vat: 50,
    //   discount: 0,
    //   total: 150,
    //   spaceCode: '562123123',
    //   licensePlate: 'กด-2525',
    //   enterAt: new Date(),
    //   exitAt: new Date(),
    //   chargingStart: new Date(),
    //   chargingEnd: new Date(),
    //   createDate: new Date(),
    //   historyUid: '54156-51561-84512',
    //   totalTime : 100
    // }
  ];

  /* -- Invoice Detail -- */
  invoiceDetail: EvChargingInvoiceResponse | null = null;
  isOpenModalInvoiceDetail: boolean = false;

  /* -- Top up --*/
  selectedInvoice: number = 0;
  isOpenModalTopup: boolean = false;
  topupAmount: CityParkingAccountTopUp = {
    accountName: '',
    accountNumber: '',
    userId: 0,
    amount: 0,
    status: 0,
  };
  selectedTransaction: ParkingUserVehicleDto | null = null;
  dateNow: Date = new Date();

  /* -- Search & Filters -- */
  searchText: string = '';

  /* -- Loading --*/
  isLoading = false;

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private toastCustomService: ToastCustomService,
    private apiTopUpService: ApiTopUpService,
    private apiEvChargerService: ApiEvChargerService,
    private apiHandler: ApiHandlerService,
    private cookieService: CookieService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  /**
   * เมธอดสำหรับกำหนดค่าเริ่มต้น ดึง Line UID และโหลดรายการใบค้างชำระ
   */
  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';

    this.getCityParkingInvoiceInfo();
  }

  /*#################################################### Function ################################################*/

  /**
   * ค้นหารายการใบค้างชำระจากกล่องคำค้นหา (คัดกรองจากชื่อสถานที่, ทะเบียน, หรือเลขที่ใบ)
   */
  get filteredInvoices(): EvChargingInvoiceResponse[] {
    if (!this.searchText || !this.searchText.trim()) {
      return this.invoiceList;
    }
    const q = this.searchText.toLowerCase().trim();
    return this.invoiceList.filter(
      (item) =>
        (item.name && item.name.toLowerCase().includes(q)) ||
        (item.siteName && item.siteName.toLowerCase().includes(q)) ||
        (item.licensePlate && item.licensePlate.toLowerCase().includes(q)) ||
        (item.spaceCode && item.spaceCode.toLowerCase().includes(q))
    );
  }

  /**
   * คำนวณหายอดรวมค้างชำระทั้งหมดที่มีอยู่
   */
  get totalPendingAmount(): number {
    if (!this.invoiceList || this.invoiceList.length === 0) return 0;
    return this.invoiceList.reduce((sum, item) => sum + (item.total || 0), 0);
  }

  /**
   * ล้างค่าข้อความในการค้นหาตัวกรอง
   */
  onClearSearch(): void {
    this.searchText = '';
  }

  /**
   * ปิด Modal รายละเอียดใบค้างชำระการชาร์จ
   */
  closeModalInvoiceDetail() {
    this.isOpenModalInvoiceDetail = false;
  }

  /**
   * ปิด Modal ยืนยันการชำระเงินด้วยบัญชีเติมเงิน
   */
  closeModalTopup() {
    this.isOpenModalTopup = false;
  }

  /**
   * แสดงแจ้งเตือนเตือนภัยหรือข้อควรระวัง (Warning)
   */
  showWarning(text: string, detail: string = '') {
    this.toastCustomService.showWarning('', text);
  }

  /**
   * แสดงแจ้งเตือนข้อผิดพลาด (Error)
   */
  showError(text: string, detail: string = '') {
    this.toastCustomService.showError('', text);
  }

  /**
   * แสดงแจ้งเตือนการดำเนินงานสำเร็จ (Success)
   */
  showSuccess(text: string, detail: string = '') {
    this.toastCustomService.showSuccess('', text);
  }

  /**
   * ย้อนกลับไปยังหน้ารายการการชาร์จ EV
   */
  goback() {
    this.router.navigate(['/ev-charger']);
  }

  /**
   * ดึงจำนวนชั่วโมงในการชาร์จจากยอดเวลาทั้งหมดหน่วยเป็นนาที
   */
  displayHours(): number | null {
    const result =
      this.invoiceDetail !== null && this.invoiceDetail !== undefined
        ? Math.floor(this.invoiceDetail.totalTime / 60)
        : null;
    return result;
  }

  /**
   * ดึงจำนวนนาทีเศษในการชาร์จจากยอดเวลาทั้งหมดหน่วยเป็นนาที
   */
  displayMinutes(): number | null {
    const result =
      this.invoiceDetail !== null && this.invoiceDetail !== undefined
        ? Math.floor(this.invoiceDetail.totalTime % 60)
        : null;
    return result;
  }

  /**
   * เปิดดูรายละเอียดใบค้างชำระที่ผู้ใช้งานเลือก และเช็คยอดคงเหลือ Wallet
   */
  onClickSeeInvoice(invoiceNo: number) {
    const filterInvoice = this.invoiceList.find((item) => item.id == invoiceNo);
    this.selectedInvoice = invoiceNo;
    this.invoiceDetail = filterInvoice || null;
    this.getTopupBalance();
  }

  /**
   * สลับไปแสดงหน้าต่างยืนยันการชำระเงินด้วย Wallet
   */
  onClickTopup() {
    this.isOpenModalInvoiceDetail = false;
    this.isOpenModalTopup = true;
  }

  /**
   * ยืนยันการตัดเงินจากบัญชีเติมเงินของรถคันปัจจุบันเพื่อชำระหนี้ค้างชำระ
   */
  paymentTopup() {
    if (this.invoiceDetail) {
      if (this.topupAmount?.amount < this.invoiceDetail.total) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'จำนวนเงินไม่เพียงพอ'
            : 'Your balance is insufficient !'
        );
        return;
      }
      const payload: PaymentTopupPenaltyPayload = {
        uid: this.uid,
        siteId: this.invoiceDetail.siteId,
        invoiceId: this.invoiceDetail.id,
        parkingfee: 0,
        penaltyFee: this.invoiceDetail.total,
        totalPay: this.invoiceDetail.total,
        topupAmount: this.topupAmount.amount,
        subscriptId: 0,
        providerId: 0,
      };

      console.log('payload top up : ', JSON.stringify(payload));
      if (payload) {
        this.isLoading = true;
        this.isOpenModalTopup = false;
        this.sentPaymentTopupPenalty(payload);
      } else {
        console.log('No payload');
      }
    } else {
      console.log('No Selected');
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง'
          : 'Data not found, please try again.'
      );
      this.isLoading = false;
    }
  }

  /*############################################# API #################################################*/

  /**
   * ดึงข้อมูลรายการใบค้างชำระการชาร์จ EV ของ Line UID ปัจจุบัน
   */
  getCityParkingInvoiceInfo() {
    this.isLoading = true;
    this.apiHandler.handleApi(
      this.apiEvChargerService.getCityParkingInvoiceInfo(this.uid, this.token),
      {
        logLabel: 'getCityParkingInvoiceInfo',
        isConsoleLog: true,
        loading: (loading) => (this.isLoading = loading),
        success: (res: EvChargingInvoiceResponse[]) => {
          if (res) {
            this.isLoading = false;
            this.invoiceList = res;
          } else {
            this.isLoading = false;
          }
        },
        error: (err) => {
          this.isLoading = false;
          // this.showError(err.message);
        },
      }
    );
  }

  /**
   * ตรวจสอบความถูกต้องและยอดเงินคงเหลือล่าสุดของกระเป๋าเงินเติมเงิน (EV Wallet)
   */
  getTopupBalance() {
    this.isLoading = true;
    this.apiHandler.handleApi(
      this.apiTopUpService.getTopUpAccount(this.uid, this.token),
      {
        logLabel: 'GetTopupBalance',
        isConsoleLog: true,
        loading: (loading) => (this.isLoading = loading),
        success: (res) => {
          if (res) {
            this.isLoading = false;
            const now = new Date();
            this.dateNow = now;
            this.isOpenModalInvoiceDetail = true;
            this.topupAmount = res;
          } else {
            this.isLoading = false;
            this.showWarning('ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง');
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.showError(err.message);
        },
      }
    );
  }

  /**
   * ส่งคำสั่งตัดเงินจาก API เพื่อชำระใบค้างชำระ EV
   */
  sentPaymentTopupPenalty(payload: PaymentTopupPenaltyPayload) {
    return this.apiHandler.handleApi(
      this.apiTopUpService.sentApiPaymentTopupPenalty(payload, this.token),
      {
        logLabel: 'PaymentTopupParking',
        loading: (loading) => (this.isLoading = loading),
        success: (res) => {
          if (res.code === '000') {
            this.isLoading = false;
            this.showSuccess(
              this.currentLang === 'TH' ? res.message : res.message_en
            );

            this.selectedTransaction = null;
            this.getCityParkingInvoiceInfo();
          } else {
            this.isLoading = false;
            this.showError(
              this.currentLang === 'TH' ? res.message : res.message_en
            );
          }
        },
        error: (err) => {
          this.showError(
            this.currentLang === 'TH'
              ? 'ส่งข้อมูลล้มเหลว กรุณาลองใหม่อีกครั้ง'
              : 'Data submission failed, please try again.'
          );
        },
        isConsoleLog: true,
      }
    );
  }
}
